import { store } from "@/store";
import { api } from "@/utils/axios";
import { loginService } from "@/service";

const canUserAccess = async (to) => {
  // 如果该页面不需要用登录直接返回true
  if (to.matched.some((record) => record.meta.authRequired === false)) return true;
  if (store.state.userInfo) return true;
  try {
    const data = await loginService.login();
    store.commit("setUserInfo", data.data[0]);
    return true;
  } catch (error) {
    return false;
  }
};

export function createNavigationGuards(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.query.open_id) {
      store.commit("setOpenId", to.query.open_id);
    }
    if (to.query.code) {
      store.commit("setCode", to.query.code);
    }
    // 验证去往的页面是否能通过验证
    const isAuthenticated = await canUserAccess(to);
    // 没通过验证就跳登录页面，通过就跳转
    if (!isAuthenticated) {
      next({ name: "Login", replace: true, query: to.query });
      return;
    }
    if (store.state.userInfo) {
      api.defaults.baseURL = `http://${store.state.userInfo.server_ip}`;
    }
    if (to.name !== "Login" && to.query.about_id) {
      next({
        name: "Detail",
        params: {
          id: to.query.about_id,
        },
        replace: true,
      });
      return;
    }
    next();
  });
}
